import React from "react";
import { ShareModal } from "../ShareModal/ShareModal";
import { MindMapContext } from "../../Context/contex";
import { UserAvatar } from "../Avatar/UserAvatar";
import DocumentMembers from "../Members/members";
import UserColor from "../UserColor/userColor";
import Modes from './modes.js'
import TemplateThumbnail from '../TemplateThumbnail/TemplateThumbnail';
import './UserDetails.css';
import TemplateActiveToggle from "../TemplateActiveToggle/TemplateActiveToggle.js";
import HeaderAvatar from "../Avatar/HeaderAvatar.jsx";
import AppLauncherModal from "../AppLauncher/AppLauncherModal.jsx";


const UserDetails = () => {
  const { documentInfo, userInfo, isTemplateDocument } = MindMapContext();
  return (
    <div className="userDetailsContainer">
      {isTemplateDocument && <TemplateActiveToggle />}
      {isTemplateDocument && <TemplateThumbnail />}
      <Modes />
      <AppLauncherModal />
      {!isTemplateDocument && <DocumentMembers />}
      {documentInfo && !isTemplateDocument && documentInfo.createBy == userInfo.userId && (
        <ShareModal />
      )}
      <UserColor />
      <HeaderAvatar/>
    </div>
  );
};

export default UserDetails;
